import React, { useEffect, useRef } from "react";

import HealthRecordsEmpty from "../HealthRecordsEmpty";
import HealthRecordsError from "../HealthRecordsError";
import Loading from "../../../../components/Loading/Loading";
import MedicalRecordsData from "./MedicalRecordsData";
import { IPetItemResponse } from "../../../../services/Standard-of-care/standard-of-care.interface";
import { useLatestHealthStatus } from "../../../../services/medical-history/medical-history.service";

type Props = {
  petData: IPetItemResponse;
  expanded: boolean;
};

const MedicalRecordsSection = (props: Props) => {
  const { petData, expanded } = props;
  const { fetchHealthStatus, healthStatus, loading, called, error } =
    useLatestHealthStatus();
  const fetchedForPet = useRef<string | null>(null);

  useEffect(() => {
    if (expanded && fetchedForPet.current !== petData.id) {
      fetchedForPet.current = petData.id;
      fetchHealthStatus(petData.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expanded, petData.id]);

  if (loading && !healthStatus) {
    return (
      <div className="flex justify-center items-center py-10">
        <Loading />
      </div>
    );
  }

  if (error) {
    return (
      <HealthRecordsError
        description="Something went wrong while loading your pet’s medical records. Please try again later."
      />
    );
  }

  if (called && !loading && !healthStatus) {
    return <HealthRecordsEmpty petData={petData} referredFrom="medical_records" />;
  }

  if (healthStatus) {
    return <MedicalRecordsData petData={petData} healthStatus={healthStatus} />;
  }

  return null;
};

export default MedicalRecordsSection;
